module.exports = __webpack_public_path__ + "3696be2812807860a208a0800f65f74c.pdf";